export default "__VITE_ASSET__DZDmSK_z__"